import React, { useState, useEffect } from "react";

// --- COMPONENTS --- //
import GoogleMapComponent from "../../components/GoogleMap.jsx";

// --- CSS --- //
import "../../styles/map.css";

// --- ASSETS --- //
import GymCard from "../../components/Cards/GymCard.jsx";

// --- Firebase --- //
import { getGymList } from "../../utilities/firestore/firestoreUtils.js";
import { getGymLocationData } from "../../utilities/firestore/firestoreUtils.js";
import SearchBar from "../../components/SearchBar.jsx";

const Map = () => {
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
    const [gymData, setGymData] = useState([]); // State to hold gym data with location data
    const [filteredGyms, setFilteredGyms] = useState([]); // State to hold filtered gym data
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // State to detect mobile device

    // Update `isMobile` on window resize
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        // Fetch the list of gyms and their location data when the component mounts
        const fetchGyms = async () => {
            const gymsIDs = await getGymList();
            const gymsData = await getGymLocationData(gymsIDs);
            setGymData(gymsData);
            setFilteredGyms(gymsData); // Initially show all gyms
        };

        fetchGyms();
    }, []);

    useEffect(() => {
        // Filter gyms based on search query (without delay)
        const result = gymData.filter(gym =>
            gym.locationData?.gymName?.toLowerCase().includes(searchQuery.toLowerCase())
        );
        
        setFilteredGyms(result);
    }, [searchQuery, gymData]); // Runs when searchQuery or gymData changes

    return (
        <div className="map-container">
            <div className="map-info-container" style={(!isFocused && isMobile && !searchQuery) ? {height: "70px"} : {height: "calc(100vh - 80px)"}}>
                <SearchBar
                    isFocused={isFocused}
                    setIsFocused={setIsFocused}
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    placeholder={"Search gyms..."}
                />
                <div>
                    {/* Results Scrollable Area */}
                    {filteredGyms.length > 0 ? (
                        filteredGyms.map((gym, index) => {
                            const gymName = gym.locationData?.gymName || "Unknown Gym"; // Safe check for gymName
                            const gymAddress = gym.locationData?.gymAddress || "Address not available";
                            const gymHours = gym.locationData?.gymHours || "Hours not available";
                            const gymEmail = gym.locationData?.gymEmail || "Email not available";
                            const gymWebsite = gym.locationData?.websiteLink || "Website not available";
                            const gymPhone = gym.locationData?.gymPhone || "Phone not available";

                            return (
                                <GymCard
                                    key={index}
                                    gymName={gymName}
                                    gymAddress={gymAddress}
                                    gymHours={gymHours}
                                    gymEmail={gymEmail}
                                    gymPhone={gymPhone}
                                    gymWebsite={gymWebsite}
                                />
                            );
                        })
                    ) : (
                        <p style={{ paddingTop: 20, color: "var(--text-primary)" }}>No results found for '{searchQuery}'.</p>
                    )}
                </div>
            </div>
            <GoogleMapComponent
                className="google-map-container"
                gymData={filteredGyms}
                zoom={10}
                useUserLocation={true}
            />
        </div>
    );
};

export default Map;